import {hasKey} from 'shared/web';

import {getRowCellValue, type RowData} from 'features/eag-grid';

import {DIRECT_SALE_ITEMS_GRID_COLUMNS} from '../constants/directSaleItemsGridColumns';

/**
 * Returns the ids of grid rows whose `type` cell matches the given direct-sale item
 * type key (LABOUR_TYPE / MATERIAL_TYPE). The type cell value is a LabeledKey object
 * ({key, label}); rows without the column (hidden or not loaded) never match.
 */
export const getDirectSaleItemRowIdsByType = (rows: RowData[], itemTypeKey: string): string[] =>
  rows
    .filter((row) => {
      const itemType = getRowCellValue(row, DIRECT_SALE_ITEMS_GRID_COLUMNS.type);
      return hasKey(itemType, 'key') && itemType.key === itemTypeKey;
    })
    .map((row) => row.id);
